import { render } from "./Quotations5.vue?vue&type=template&id=6f06cb34"
import script from "./Quotations5.vue?vue&type=script&lang=js"
export * from "./Quotations5.vue?vue&type=script&lang=js"
script.render = render

export default script